<template>
  <div id="Home">
    <section id="HomeBanner" class="home-banner-container pb-5 brand-text">
      <div class="content-container">
        <div class="row home-banner align-items-center">
          <div class="home-banner-text col-md-7 col-sm-12">
            <h3 class="welcome brand-text">WELCOME</h3>
            <h1 class="home-banner-title brand-highlight-1 mb-3">
              Support for your Wellbeing, Every single day
            </h1>
            <p class="white-text mb-4 semi-bold">
              Whether you're looking to build healthier habits, support your mental health, or simply feel more like yourself – we're here for you every step of the way.
            </p>
            <b-button
              @click="navigate('/content/articles')"
              variant="cta"
              squared
              class="mb-4"
            >Explore our content library, full of articles and videos to help you be your best.</b-button>
          </div>
          <div class="col-md-5 d-flex flex-row justify-content-center">
            <img src="/img/home-banner.svg" class="img-fluid" />
          </div>
        </div>
      </div>
    </section>
    <section class="content-container my-5 pb-5" v-if="showResults">
      <div class="row mx-0">
        <div
          class="healthscore-banner bg-white col-md-8 col-12 shadow d-flex flex-column flex-md-row align-items-start align-items-md-center px-4 px-md-5 py-4"
        >
          <div class="d-none d-md-block">
            <img src="/img/chart.svg" class="img-fluid" />
          </div>
          <div class="d-flex flex-column align-items-start px-0 px-md-5 mb-3 mb-md-0">
            <h3 class="pb-0">Health assessments</h3>
            <p class="p-text-sm mb-0 pb-0">
              View your health assessment results
            </p>
          </div>
          <b-button
            @click="navigate('/results')"
            variant="cta"
            squared
            class="d-flex flex-row align-items-center justify-content-center py-4 ml-md-auto align-self-stretch align-self-md-auto"
            >View&nbsp;results<i class="ml-3 fas fa-chevron-right"></i
          ></b-button>
        </div>
      </div>
    </section>
    <section
      class="pt-5 my-5"
      v-if="showServiceTilesWith247Helpline && serviceTiles.length > 0"
    >
      <div class="my-5 px-4 content-container">
        <h2 class="section-title mb-3">How can we help you today?</h2>
      </div>
      <div class="position-relative">
        <div class="container">
          <AutomaticCarousel :items="serviceTiles">
            <template #default="{ item }">
              <PromotionalCard
                :item="item"
                @card-click="handleServiceCardClick"
              />
            </template>
          </AutomaticCarousel>
        </div>
        <div class="d-flex flex-row flex-nowrap blur-container">
          <div class="left-blur"></div>
          <div class="container w-100"></div>
          <div class="right-blur"></div>
        </div>
      </div>
    </section>
    <hr
      class="horizontal-divider content-container pb-5"
      v-if="showServiceTilesWith247Helpline && serviceTiles.length > 0"
    />
    <section
      class="home-section-container pb-5"
      v-for="(service, i) in content.coaching_services"
    >
      <div class="content-container">
        <div class="row home-section mx-0 align-items-center">
          <div
            class="col-md-5 d-flex flex-row justify-content-center mb-5"
            :class="{ 'd-md-none': i % 2 !== 0 }"
          >
            <img :src="service.image_url" class="img-fluid" />
          </div>
          <div class="home-section-text col-md-7 col-sm-12">
            <h3 class="p-text-lg mb-5">{{ service.name }}</h3>
            <p class="white-text mb-5 semi-bold">
              {{ service.description }}
            </p>
            <b-button
              variant="cta-outline"
              @click="navigate(service.link)"
              squared
              >{{ service.button_text }}
              <i class="fas fa-chevron-right ml-3"></i
            ></b-button>
          </div>
          <div
            class="col-md-5 d-none  d-md-flex flex-row justify-content-center"
            v-if="i % 2 !== 0"
          >
            <img :src="service.image_url" class="img-fluid" />
          </div>
        </div>
      </div>
    </section>
    <section
      class="content-container pt-5 my-5"
      v-if="content?.event_services?.length > 0"
    >
      <h2 class="section-title">Health assessments</h2>
      <div
        class="home-card-container"
        :class="{ half: content.event_services.length === 2 }"
      >
        <div
          class="home-card shadow"
          v-for="(tile, i) in content.event_services"
        >
          <div class="home-card-image ">
            <img class="img-fluid" :src="tile.image_url" />
          </div>
          <div class="home-card-container">
            <h4 class="home-card-title">{{ tile.name }}</h4>
            <p class="home-card-text">
              {{ tile.description }}
            </p>
            <div class="mt-auto">
              <b-button
                variant="cta"
                @click="navigate(tile.link)"
                squared
                class="w-100"
                >{{ tile.button_text }} <i class="fas fa-chevron-right ml-3"></i
              ></b-button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="py-5 carousel-container">
      <HomeCardCarousel
        :title="'Events'"
        type="corporateEvent"
        cardType="corporateEvent"
        class="car"
        :mute="true"
        :hideIfEmpty="true"
        :ignoreGlobalFilters="true"
        :bottomNav="true"
      >
      </HomeCardCarousel>
    </div>
    <PromotionalCarousel />

    <hr class="horizontal-divider content-container pb-5 mt-5 mb-5" />

    <div class="pt-5 carousel-container">
      <HomeFilters />

      <HomeCardCarousel
        title="Videos"
        class="car"
        type="standaloneArticles"
        additionalTag="Videos"
        :mute="true"
        :bottomNav="true"
      >
      </HomeCardCarousel>
      <HomeCardCarousel
        title="Articles"
        class="car"
        cardType="article"
        type="standaloneArticles"
        additionalTag="Articles"
        :mute="true"
        :bottomNav="true"
      >
      </HomeCardCarousel>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import config from "../config/constants";
import Loader from "../components/Loader.vue";
import HomeCardCarousel from "@/components/Home/New/HomeCardCarousel.vue";
import HomeFilters from "@/components/Home/New/HomeFilters.vue";
import EventBus from "@/helpers/eventbus";
import PromotionalCarousel from "../components/Home/New/PromotionalCarousel.vue";
import PromotionalCard from "@/components/Home/New/PromotionalCard.vue";
import AutomaticCarousel from "@/components/Carousels/AutomaticCarousel.vue";

export default {
  name: "home",
  components: {
    PromotionalCarousel,
    PromotionalCard,
    AutomaticCarousel,
    Loader,
    HomeCardCarousel,
    HomeFilters
  },
  data() {
    return {
      courses: {},
      tag: "Show all",
      content: false,
      showResults: false
    };
  },
  mounted() {
    let self = this;
    this.getHomeContent();
    this.getResults();
    EventBus.$on("setTag", function(tag) {
      self.tag = tag;
    });
  },
  methods: {
    async getResults() {
      const url =
        config.api_env + "/application/api/u/sapphire/events/user-assessments";
      const payload = {
        user_id: this.$store.getters.user_id
      };
      let res = await this.axios.post(url, payload, config.options);
      if (res.data.success) {
        this.showResults = res.data.reports.length > 0;
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    },
    async getHomeContent() {
      const url =
        config.api_env + "/application/api/u/sapphire/home/web-landing";
      const payload = {
        user_id: this.$store.getters.user_id
      };
      let res = await this.axios.post(url, payload, config.options);
      if (res.data.success) {
        this.content = res.data;
        this.loading = false;
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    },
    navigate(route) {
      this.$router.push(route);
      this.scrollToRef(null, true);
    },
    handleServiceCardClick(item) {
      if (item.link) {
        if (item.link.startsWith("tel:")) {
          window.location.href = item.link;
        } else {
          this.navigate(item.link);
        }
      }
    }
  },
  computed: {
    supportContacts() {
      return this.$store.state.user.support_contacts;
    },
    // The 24/7 helpline tile is hardcoded to be returned by the web_landing endpoint even if a user has no EAP services.
    showServiceTilesWith247Helpline() {
      const hasEventServices = this.content?.event_services?.length > 0;
      const hasEapTile = !!this.content?.eap_tile?.[0]?.name;
      return hasEventServices || hasEapTile;
    },
    serviceTiles() {
      if (!this.content) return [];

      const toItem = tile => ({
        name: tile.name,
        description: tile.description,
        image_url: tile.image_url,
        button_text: tile.button_text,
        link: tile.link
      });

      const serviceTiles = this.content.service_tiles || [];
      const eapServiceTile = serviceTiles.find(t => t.slug === "eap");
      const restServiceTiles = serviceTiles.filter(t => t.slug !== "eap");

      const eapTile = this.content.eap_tile?.[0];
      const eapTileItem = eapTile?.name
        ? {
            name: eapTile.name,
            description: eapTile.description,
            image_url: eapTile.image_url,
            button_text: eapTile.cta_text,
            link: eapTile.tel ? "tel:" + eapTile.tel.replace(/\s+/g, "") : null
          }
        : null;

      const tiles = [
        ...(eapServiceTile ? [toItem(eapServiceTile)] : []),
        ...(eapTileItem ? [eapTileItem] : []),
        ...restServiceTiles.map(toItem),
        ...(this.content.additional_services || []).map(toItem)
      ];

      return tiles;
    }
  }
};
</script>
<style lang="less">
#Home {
  overflow-x: hidden;
  background-color: #fafafa !important;

  .welcome {
    font-size: 1.8rem;
    font-weight: 700;
    letter-spacing: 2.2px;
  }

  .content-container {
    padding-right: 16px;
    padding-left: 16px;
  }

  .home-banner-container {
    .home-banner {
      padding: 60px 16px 30px;
    }

    .home-banner-text {
      font-size: 1.6rem;
      z-index: 2;

      .home-banner-title {
        font-size: 6.4rem;
        font-weight: bold;
        padding-bottom: 25px;
      }

      p {
        font-size: 1.8rem;
      }
    }

    div {
      z-index: 2;
    }
  }

  .home-section-container {
    .home-section {
      padding-top: 30px;
    }

    .img-fluid {
      width: 100%;
      height: 246px;
      object-fit: cover;
      object-position: center;
    }

    .home-section-text {
      text-wrap-style: balance;
      font-size: 1.6rem;
      z-index: 2;

      .home-section-title {
        font-size: 6.4rem;
        font-weight: bold;
        padding-bottom: 25px;
      }

      p {
        font-size: 1.8rem;
      }
    }

    div {
      z-index: 2;
    }
  }

  .section-title {
    font-size: 2.8rem;
  }

  .healthscore-banner {
    border-radius: 6px;

    h3 {
      font-size: 2.4rem;
    }
  }

  .home-card-cta-text {
    font-size: 1.6rem;
    font-weight: 500;
  }

  .blur-container {
    pointer-events: none;
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;

    .container {
      flex-grow: 1;
    }

    .left-blur {
      flex-grow: 1;
      background: linear-gradient(
        270deg,
        rgba(250, 250, 250, 0) 5%,
        rgba(250, 250, 250, 0.7) 15%,
        rgba(250, 250, 250, 1) 45%
      );
    }

    .right-blur {
      flex-grow: 1;
      background: linear-gradient(
        90deg,
        rgba(250, 250, 250, 0) 5%,
        rgba(250, 250, 250, 0.7) 15%,
        rgba(250, 250, 250, 1) 45%
      );
    }
  }

  @media only screen and (max-width: 768px) {
    .home-card-container {
      grid-template-columns: 1fr !important;
    }
  }

  @media only screen and (max-width: 768px) {
    .home-card-container {
      grid-template-columns: 1fr !important;
    }
  }

  .home-card-container.half {
    grid-template-columns: 1fr 1fr;
  }

  .home-card-container {
    padding-bottom: 30px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 30px;

    .home-card {
      background-color: white;
      border-radius: 8px;
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;
      z-index: 2;
      flex-grow: 1;

      .home-card-container {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        padding: 15px;
      }

      h4 {
        font-size: 1.8rem;
        font-weight: bold;
        margin-bottom: 15px;
        z-index: 10;
      }

      p {
        font-size: 1.4rem;
        z-index: 10;
        margin-bottom: 20px;
      }

      .home-card-image {
        .img-fluid {
          width: 100%;
          height: 246px;
          object-fit: cover;
          object-position: center;
        }
      }

      .home-card-button {
        margin-left: -10px;
        padding: 10px;
        font-size: 1.4rem;
      }
    }
  }

  .home-section-container {
    .home-section {
      padding-top: 30px;
    }

    .img-fluid {
      width: 100%;
      height: 246px;
      object-fit: cover;
      object-position: center;
    }

    .home-section-text {
      font-size: 1.6rem;
      z-index: 2;

      .home-section-title {
        font-size: 6.4rem;
        font-weight: bold;
        padding-bottom: 25px;
      }

      p {
        font-size: 1.8rem;
      }
    }

    div {
      z-index: 2;
    }
  }

  .section-title {
    font-size: 2.8rem;
  }

  .healthscore-banner {
    border-radius: 6px;

    h3 {
      font-size: 2.4rem;
    }
  }

  @media only screen and (max-width: 768px) {
    .home-card-container {
      grid-template-columns: 1fr !important;
    }
  }

  @media only screen and (max-width: 768px) {
    .home-card-container {
      grid-template-columns: 1fr !important;
    }
  }

  .home-card-container.half {
    grid-template-columns: 1fr 1fr;
  }

  .home-card-container {
    padding-bottom: 30px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 30px;

    .home-card {
      background-color: white;
      border-radius: 8px;
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;
      z-index: 2;
      flex-grow: 1;

      .home-card-container {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        padding: 15px;
      }

      h4 {
        font-size: 1.8rem;
        font-weight: bold;
        margin-bottom: 15px;
        z-index: 10;
      }

      p {
        font-size: 1.4rem;
        z-index: 10;
        margin-bottom: 20px;
      }

      .home-card-image {
        .img-fluid {
          width: 100%;
          height: 246px;
          object-fit: cover;
          object-position: center;
        }
      }

      .home-card-button {
        margin-left: -10px;
        padding: 10px;
        font-size: 1.4rem;
      }
    }
  }
}
</style>
